import { render } from "./wysiwyg.vue?vue&type=template&id=79c42aa8"
import script from "./wysiwyg.vue?vue&type=script&lang=js"
export * from "./wysiwyg.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/components/form/input-only/wysiwyg.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "79c42aa8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('79c42aa8', __exports__)) {
    console.log('reload')
    api.reload('79c42aa8', __exports__)
  }
  
  module.hot.accept("./wysiwyg.vue?vue&type=template&id=79c42aa8", () => {
    console.log('re-render')
    api.rerender('79c42aa8', render)
  })

}


export default __exports__